declare global {
  // eslint-disable-next-line id-blacklist
  interface String {
    fullTrim(): string;
    compareByValue(s1: string): boolean;
    entityValue(): string;
  }

  interface StringConstructor {
    isNullOrWhiteSpace(value: string): boolean;
  }
}

String.isNullOrWhiteSpace = (value: string): boolean => {
  return value == null || value.trim() === '';
};

String.prototype.fullTrim = function (): string {
  return this.trim().replace(/[\s]+/g, ' ');
};

String.prototype.compareByValue = function (s1: string): boolean {
  return this?.trim()?.toLowerCase() === s1?.trim()?.toLowerCase();
};

String.prototype.entityValue = function (): string {
  return this?.trim()?.toLowerCase();
};

export {};
